import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Presentation, X } from "@phosphor-icons/react";
import { useApi, errText } from "@/lib/api";

export const DemoLogins = () => {
  const api = useApi();
  const qc = useQueryClient();
  const admin = useQuery({ queryKey: ["admin-status"], queryFn: () => api.get("/admin/status"), staleTime: Infinity });
  const { data } = useQuery({ queryKey: ["demo-logins"], queryFn: () => api.get("/admin/demo-logins"), enabled: !!admin.data?.is_admin });
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  if (!admin.data?.is_admin || !data) return null;
  const save = async (emails, done) => {
    setBusy(true);
    try {
      const r = await api.put("/admin/demo-logins", { emails });
      qc.setQueryData(["demo-logins"], r);
      done?.();
      toast.success("Demo logins updated");
    } catch (e) { toast.error(errText(e, "Couldn't save demo logins")); }
    setBusy(false);
  };
  const add = (e) => { e.preventDefault(); if (email.trim()) save([...data.emails, email.trim()], () => setEmail("")); };
  return (
    <section data-testid="demo-logins-section" className="rounded-xl border border-[#B026FF]/40 bg-[#121212] p-6">
      <h2 className="font-display text-xl flex items-center gap-2"><Presentation className="text-[#D9A6FF]" /> Demo logins</h2>
      <p className="mt-2 text-sm text-[#A3A3A3]">Separate sign-ins you can use for sales demos. Each gets its own free Pro account and a Demo mode button, without your admin pages. Sign up with the address first, then add it here (up to 3).</p>
      <ul className="mt-4 space-y-2">
        {data.emails.map((e) => (
          <li key={e} data-testid={`demo-login-${e}`} className="flex items-center justify-between rounded-lg border border-[#2A2A2A] px-3 py-2 text-sm">
            {e}
            <button data-testid={`demo-login-remove-${e}`} disabled={busy} onClick={() => save(data.emails.filter((x) => x !== e))}
              className="text-[#6B6B6B] hover:text-[#FF5C7A] transition-colors" aria-label={`Remove ${e}`}><X size={14} /></button>
          </li>
        ))}
        {data.emails.length === 0 && <li data-testid="demo-logins-empty" className="text-xs text-[#6B6B6B]">No demo logins yet.</li>}
      </ul>
      {data.emails.length < 3 && (
        <form onSubmit={add} className="mt-4 flex gap-2">
          <input data-testid="demo-login-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="sonia+demo@soniamontez.com"
            className="flex-1 rounded-full border border-[#2A2A2A] bg-[#050505] px-4 py-2 text-sm outline-none focus:border-[#B026FF]" />
          <button data-testid="demo-login-add-btn" disabled={busy} className="rounded-full bg-white px-4 py-2 text-xs font-semibold text-[#050505] hover:bg-[#00FF9D] transition-colors disabled:opacity-50">Add</button>
        </form>
      )}
    </section>
  );
};
